import { COLORS, GRADIENTS, Gradient } from '../../config/designSystem/Colors';
import { FC } from 'react';
import { GradientView } from '../Gradients/GradientView';
import { SPACING } from '../../config/designSystem/Spacing';
import { Title3 } from '../../config/designSystem/typography';
import { TouchableOpacity, View } from 'react-native';


export interface ToggleSelectedElementProps {
    label:string;
    onPress: () => void;
  }


export const ToggleSelectedElement: FC<ToggleSelectedElementProps>= ({label, onPress} : ToggleSelectedElementProps) => {
  return(
    <TouchableOpacity
      onPress={onPress}>
      <GradientView gradient={GRADIENTS.brand['primary-light'] as Gradient} style={{
        borderRadius: SPACING['sp-8'],
        paddingVertical: SPACING['sp-8'],
        paddingHorizontal: SPACING['sp-12'],
        alignItems:'center'

      }} >


        <View style={{      alignItems:'center'}} >


          <Title3 color={COLORS.content['inverse-primary']}>{label}</Title3>

        </View>
      </GradientView>
    </TouchableOpacity>

  );

};



